/**
 * The shadcn theme follows the `dark` class on `<html>`. The existing preference (`saay-theme` /
 * `data-theme`, or the system scheme when unset) stays the source; this only mirrors it.
 */

function prefersDark(): boolean {
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
}

export function syncDarkClass(): void {
  const root = document.documentElement;
  const choice = root.dataset.theme;
  const dark = choice === 'dark' || (choice !== 'light' && prefersDark());
  root.classList.toggle('dark', dark);
}

/** Keeps the `dark` class aligned with theme toggles and the system scheme. */
export function watchDarkClass(): () => void {
  syncDarkClass();
  const root = document.documentElement;
  const observer = new MutationObserver(syncDarkClass);
  observer.observe(root, { attributeFilter: ['data-theme'], attributes: true });
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const onMedia = () => syncDarkClass();
  media.addEventListener('change', onMedia);
  return () => {
    observer.disconnect();
    media.removeEventListener('change', onMedia);
  };
}
